import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import api from '../lib/api';

const MillsContext = createContext({ principals: [], cfg: {}, principalFor: () => null });

export const useMills = () => useContext(MillsContext);

const norm = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

/** Principal mills and their display toggles, fetched once for the whole site. */
export function MillsProvider({ children }) {
  const [partners, setPartners] = useState([]);
  const [cfg, setCfg] = useState({});

  useEffect(() => {
    api.get('/partners/public').then(r => setPartners(r.data || [])).catch(() => {});
    api.get('/settings/public/mills_display').then(r => setCfg(r.data || {})).catch(() => {});
  }, []);

  const value = useMemo(() => {
    const principals = partners.filter(p => p.principal);
    /** A grade's brand belongs to a principal mill when either name contains the other. */
    const principalFor = (brand) => {
      const b = norm(brand);
      if (!b) return null;
      return principals.find(m => {
        const n = norm(m.name);
        return n === b || n.startsWith(b) || b.startsWith(n);
      }) || null;
    };
    return { principals, cfg, principalFor };
  }, [partners, cfg]);

  return <MillsContext.Provider value={value}>{children}</MillsContext.Provider>;
}
